import { render, staticRenderFns } from "./EditMyBankDetailsDialog.vue?vue&type=template&id=b72ebccc&scoped=true&"
import script from "./EditMyBankDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./EditMyBankDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditMyBankDetailsDialog.vue?vue&type=style&index=0&id=b72ebccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72ebccc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
